import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { GetLocationLookupRequest, LocationLookup } from "../../domain";
import { Observable } from "rxjs";
import { LocationsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetLookupLocationsByJobIdUsecase implements UseCase<GetLocationLookupRequest, LocationLookup[]> {

  constructor(private LocationsRepository: LocationsRepository) {
  }

  execute(params?: GetLocationLookupRequest): Observable<LocationLookup[]> {
    return this.LocationsRepository.getLookupLocationsByJobId(params ?? {});
  }

}
